<template>
  <div v-loading="isLoading">
    <slot name="content-top"></slot>
    <div>
      <div class="doc-plan-action">
        <el-link
          href="https://docs.smartkeyword.io/fr/articles/3384866-plan-d-action-focus-contenu"
          target="_blank"
          type="primary"
          :underline="false"
        >
          <i class="fas fa-question-circle"></i>
          <span>{{ $t("documentationDesc") }}</span>
        </el-link>
      </div>
      <div class="content">
        <div>
          <div>
            <el-alert
              :title="$t('warning')"
              type="warning"
              :description="this.$i18n.t('incomplete')"
              show-icon
              style="margin-bottom: 0.5rem; width: 800px"
            >
            </el-alert>
          </div>
          <div class="text-options">
            <h4>{{ $t("textOfYourPage") }}</h4>
            <div class="d-flex flex-row justify-content-end">
              <el-button
                v-if="url != null"
                type="secondary"
                plain
                @click="resetEditor()"
                ><i class="fas fa-undo"></i>
                {{ $t("reloadOriginalText") }}</el-button
              >
              <el-button
                v-if="url != null"
                type="secondary"
                plain
                @click="callContentExtraction(true)"
                >  
                <el-tooltip
                    :content="$t('tooltipExtractContent')"
                  >
                    <i class="fas fa-question-circle"></i>
                </el-tooltip>
                {{ $t("extractContentWithAi") }}</el-button
              >
              <el-button
                type="primary"
                plain
                @click="callContentOptimization()"
                >{{ $t("refreshScores") }}</el-button
              >
            </div>
          </div>

          <el-card>
            <div
              class="editor"
              @click="startEditing"
              style="width: 880px"
              v-loading="isLoadingContentExtraction"
            >
              <TiptapEditor
                v-model="contentText"
                :radioContentToDisplay="radioContentToDisplay"
                :isEditable="true"
                :height="textEditorheight"
                :generateContent="generateContent"
              >
              </TiptapEditor>
            </div>
          </el-card>
        </div>
        <div class="right">
          <div
            v-if="url == null"
            class="my-3"
          >
            <el-alert
              :title="$t('warning')"
              type="error"
              :description="this.$i18n.t('warningMessage')"
              show-icon
            >
            </el-alert>
            <slot name="associate-page"></slot>
          </div>
          <div class="chatgptSelectors">
            <el-button
              class="buttonNotClicked"
              :class="{ clicked: !isChatGptSelected }"
              @click="selectTableContent(false)"
              >Score</el-button
            >
            <el-button
              class="buttonNotClicked"
              :class="{ clicked: isChatGptSelected }"
              @click="selectTableContent(true)"
              >GenAI</el-button
            >
          </div>
          <div v-if="!isChatGptSelected">
            <el-card
              v-loading="isLoadingContentOptimization"
              style="margin-bottom: 1rem"
            >
              <seo-scores
                :ownScore="Math.round(seoScore)"
                :serpScore="Math.round(serpSeoScore)"
              >
              </seo-scores>
            </el-card>
            <el-card>
              <div>
                <h1-scores
                  v-loading="isLoadingContentOptimization"
                  :ownScore="Math.round(h1Scores.ownScore)"
                  :serpScore="Math.round(h1Scores.serpScore)"
                  :ownH1="ownH1"
                >
                  <el-button
                    class="mt-2"
                    size="mini"
                    type="secondary"
                    plain
                    @click="showH1Dialog()"
                    :disabled="!isDataFinished"
                    >{{ $t("seeMore") }}</el-button
                  >
                </h1-scores>
                <el-divider class="divider" />
                <content-length-scores
                  v-loading="isLoadingContentOptimization"
                  :ownScore="Math.round(contentLengthScores.ownScore)"
                  :serpScore="Math.round(contentLengthScores.serpScore)"
                  :askedContentLength="metaContentsData.contentMedian"
                  :contentLength="contentLength"
                >
                  <el-button
                    class="mt-2"
                    size="mini"
                    type="secondary"
                    plain
                    @click="showContentLengthDialog()"
                    :disabled="!isDataFinished"
                    >{{ $t("seeMore") }}</el-button
                  >
                </content-length-scores>
                <el-divider class="divider" />
                <content-relevance-scores
                  v-loading="isLoadingContentOptimization"
                  :ownScore="Math.round(contentRelevanceScores.ownScore)"
                  :serpScore="Math.round(contentRelevanceScores.serpScore)"
                >
                  <el-tooltip
                    class="item"
                    :disabled="!!seoScores"
                    :content="$t('seoScoreGeneration')"
                    placement="top"
                  >
                    <span>
                      <el-button
                        size="mini"
                        type="secondary"
                        plain
                        @click="showOptimizationSeoDialog()"
                        :disabled="!!!seoScores"
                        >{{ $t("seeMore") }}</el-button
                      >
                    </span>
                  </el-tooltip>
                </content-relevance-scores>
              </div>
              <keywords-to-use-collapse
                v-if="recommendedKeywords.length > 0"
                :recommendedKeywords="recommendedKeywords"
                :peopleAlsoAskKeywords="peopleAlsoAskKeywords"
                :relatedKeywords="relatedKeywords"
                @collapse-change-event="keywordsToUseCollapseEvent"
              >
              </keywords-to-use-collapse>
            </el-card>
          </div>
          <div v-else>
            <div class="loadingTextStyle">
              <div v-if="isLoadingAI">
                <span class="text-center">{{ $t("dataFetchGpt") }}</span>
                <div
                  class="loadingStyle"
                  v-loading="isLoadingAI"
                ></div>
              </div>
            </div>
            <Table
              v-if="!isLoadingAI"
              :responseAI="responseApiAi"
              :isAuthorized="isAuthorized"
              @radioEvent="handleRadioEvent"
              @genAiEvent="handleGenAIEvent"
            />
          </div>
          <H1Dialog
            v-model="isH1DialogVisible"
            :metaContentsData="metaContentsData"
            :keyword="keyword"
          >
            <h1-scores
              v-loading="isLoadingContentOptimization"
              :isActionPlanDialog="true"
              :ownScore="Math.round(h1Scores.ownScore)"
              :serpScore="Math.round(h1Scores.serpScore)"
              :ownH1="ownH1"
            >
            </h1-scores>
          </H1Dialog>
          <ContentLengthDialog
            v-model="isContentLengthDialogVisible"
            :metaContentsData="metaContentsData"
            :keyword="keyword"
          >
            <content-length-scores
              v-loading="isLoadingContentOptimization"
              :isActionPlanDialog="true"
              :ownScore="Math.round(contentLengthScores.ownScore)"
              :serpScore="Math.round(contentLengthScores.serpScore)"
              :askedContentLength="metaContentsData.contentMedian"
              :contentLength="contentLength"
            >
            </content-length-scores>
          </ContentLengthDialog>
          <OptimizationSeoDialog
            v-if="seoScores"
            :seoScores="seoScores"
            v-model="isOptimizationSeoDialogVisible"
            :metaContentsData="metaContentsData"
            :defaultSearchEngine="defaultSearchEngine"
            :contentOptimizationData="contentOptimizationData"
            :keyword="keyword"
          >
            <content-relevance-scores
              v-loading="isLoadingContentOptimization"
              :isActionPlanDialog="true"
              :ownScore="Math.round(contentRelevanceScores.ownScore)"
              :serpScore="Math.round(contentRelevanceScores.serpScore)"
            >
            </content-relevance-scores>
          </OptimizationSeoDialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentLengthDialog from "@/pages/ActionPlan/Content/ContentLengthDialog.vue";
import H1Dialog from "@/pages/ActionPlan/Content/H1Dialog.vue";
import OptimizationSeoDialog from "@/pages/ActionPlan/Content/OptimizationSeoDialog.vue";

import TiptapEditor from "@/components/TiptapV2.vue";
import KeywordsToUseCollapse from "@/components/ContentOptimization/KeywordsToUseCollapse.vue";
import SeoScores from "@/components/ContentOptimization/SeoScores.vue";
import H1Scores from "@/components/ContentOptimization/H1Scores.vue";
import ContentLengthScores from "@/components/ContentOptimization/ContentLengthScores.vue";
import ContentRelevanceScores from "@/components/ContentOptimization/ContentRelevanceScores.vue";
import { contentOptimizationMixin } from "@/mixins/contentOptimizationMixin.js";
import Table from "@/pages/ActionPlan/Content/chatGptTable/table.vue";

import { mapState } from "vuex";

export default {
  mixins: [contentOptimizationMixin],
  props: {
    country: String,
    keyword: Object,
    url: String,
    crawl: Object,
    tagsUrlDetails: Array,
    language: String,
    seoScores: Array,
    metaContentsData: Object,
    defaultSearchEngine: Object,
    isAuthorized: Boolean
  },
  components: {
    TiptapEditor,
    KeywordsToUseCollapse,
    SeoScores,
    H1Scores,
    ContentLengthScores,
    ContentRelevanceScores,
    ContentLengthDialog,
    H1Dialog,
    OptimizationSeoDialog,
    Table,
  },
  data() {
    return {
      oldValue: "",
      contentText: "",
      tagTitle: "",
      oldTagTitle: "",
      tagMetaDescription: "",
      oldTagMetaDescription: "",
      input: "",
      activeTab: "performances",
      originalEditor: "",
      body: {},
      firstInsert: true,
      contentOptimizationData: null,
      isContentLengthDialogVisible: false,
      isH1DialogVisible: false,
      isOptimizationSeoDialogVisible: false,
      isLoading: false,
      isLoadingContentExtraction: false,
      textEditorheight: 1250,

      isChatGptSelected: false,
      responseApiAi: null,
      isLoadingAI: true,
      radioContentToDisplay: null,
      aiContentText: null,
      generateContent: null
    };
  },
  methods: {
    selectTableContent(booleanValue) {
      this.isChatGptSelected = booleanValue;
      if (booleanValue) this.callAIsuggestionContent();
    },
    callContentOptimization() {
      this.isLoadingContentOptimization = true;
      this.saveEdit();
      this.body.searchEngine.device = this.study.devices[0];
      if (this.contentText == "<p></p>" || this.contentText == "") {
        this.body.content = this.originalEditor;
      } else {
        this.body.content = this.contentText;
      }
      this.$apiV2
        .post("/semantic/content-optimization", this.body)
        .then((response) => {
          this.contentOptimizationData = response.data.data;
          this.isLoadingContentOptimization = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoadingContentOptimization = false;
        });
    },
    startEditing() {
      this.oldValue = this.contentText;
    },
    saveEdit() {
      this.oldValue = this.contentText;
      this.$emit("input", this.contentText);
    },
    cancelChanges() {
      this.contentText = this.oldValue;
    },
    callAIsuggestionContent() {
      const body = {
        data: {
          type: "AI_SUGGESTIONS_REQUEST",
          attributes: {
            keyword: {
              text: this.keyword.text,
              locationId: this.keyword.loc_id,
            },
            searchEngineParameters: {
              isoCountryCode: this.study.isoCountryCode,
              device: this.study.devices[0],
              isoLanguageCode: this.study.isoLanguageCode,
            },
            types: ["H1", "PLAN"],
            size: 5,
          },
        },
      };
      if (!this.responseApiAi) {
        this.isLoadingAI = true;
        this.$apiV2
          .post("/ai/suggestions", body)
          .then((response) => {
            this.responseApiAi = response.data.data.attributes;
            this.isLoadingAI = false;
          })
          .catch((error) => {
            this.isLoadingAI = false;
            console.error(error);
          });
      }
    },
    callContentExtraction(withAi = false) {
      this.isLoadingContentExtraction = true;
      let url = "/semantic/content-extraction"
      const req = { url: this.url };
      if(withAi) {
        url = url + "?mode=ai"
      }
      var ctr = this.country.split("-");
      this.body = {
        searchEngine: { country: ctr[1], language: this.language },
      };
      this.body.keyword = { text: this.keyword.text };
      if (!this.url) {
        this.originalEditor = "";
        this.callContentOptimization();
        this.isLoadingContentExtraction = false;
        return;
      }
      this.$apiV2
        .post(url, req, { timeout: 300000 })
        .then((response) => {
          const titlesArray = response.data.data.titles;
          const metaDescriptionsArray = response.data.data.metaDescriptions;

          this.originalEditor = response.data.data.htmlContent;
          if (titlesArray && titlesArray.length) {
            this.tagTitle = titlesArray[0];
            this.oldTagTitle = titlesArray[0];
          }
          if (metaDescriptionsArray && metaDescriptionsArray.length) {
            this.tagMetaDescription = metaDescriptionsArray[0];
            this.oldTagMetaDescription = metaDescriptionsArray[0];
          }
          this.contentText = this.originalEditor;
          this.callContentOptimization();
          this.isLoadingContentExtraction = false;
        })
        .catch((error) => {
          console.error(error);
          this.originalEditor = "";
          this.callContentOptimization();
          this.isLoadingContentExtraction = false;
        });
    },
    async callAiGeneration(clickValue) {
      this.isLoadingContentExtraction = true;

      const h1sString = this.responseApiAi.h1s.join('\n');
      const paa = this.peopleAlsoAskKeywords.join('\n');
      const relatedKeywords = this.relatedKeywords.join('\n');
      const plansString = this.responseApiAi.plan.h1s.map(e => JSON.stringify(e)).join('---');
      const recommendedKeywords = this.extractFromRecommandedKeywords(this.recommendedKeywords);

      let body = {}
      if (clickValue === "generate")
        body = this.createPromptForGeneration(this.language, this.keyword, this.metaContentsData, h1sString, plansString, paa, relatedKeywords, recommendedKeywords);
      else {
        body = this.createPromptForOptimization(this.contentText, this.keyword, this.metaContentsData, h1sString, plansString, paa, relatedKeywords, recommendedKeywords);
      }

      await this.$apiV2
        .post("/ai/generation", body)
        .then((response) => {
          this.aiContentText = response.data.data.attributes.aiResponse;
        })
        .catch((error) => {
          this.isLoadingContentExtraction = false;
          console.error(error);
        });
    },
    createPromptForGeneration(language, keyword, length, h1sString, plansString, paa, relatedKeywords, recommendedKeywords) {
      return {
        data: {
          type: "AI_GENERATION_REQUEST",
          attributes: {
            model: "gpt-4o",
            messages: [
              {
                role: "system",
                content: "Tu es un rédacteur professionnel spécialisé dans l'écriture de contenu de site web de haute qualité, optimisé avec toutes les meilleures pratiques SEO.\nTu adhères aux briefs donnés par tes clients, tu portes une attention particulière à l'orthographe et la grammaire.\nLe contenu que tu génères respecte un plan clair et détaillé que tu auras préalablement imaginé, ce contenu généré est formatté en html afin de pouvoir clairement mettre ce plan en valeur via des sections détaillées (h1, h2 ...), ceci étant tu limites ces sections en nombre (typiquement aux alentours de 5) afin de ne pas trop hâcher le texte et que chaque paragraphe soit riche en contenu ! Afin que le texte soit dynamique et visuellement riche, tu emploies judicieusement les espacements, séparations en paragraphes, et tu mets en valeur certains mots et expressions importantes en gras. La longueur du texte peut varier mais tu n'écris jamais moins de 500 mots pour éviter les plaintes des clients.\nTu es multi-lingue et sait respecter les différentes conventions orthographiques et références culturelles de chaque pays, par exemple là où l'anglais utilise les apostrophoes (\"\") pour une citation, le français utilise les guillements («»), les espaces diffèrent également (le français par exemple sépare par deux espaces certains signes de ponctuation comme le point d'interrogation, d'exclamation ... La façon de génerer les majuscules n'est également pas la même).\nLe contenu que tu génères est automatiquement intégré par le client sur son site, donc il ne comporte aucun commentaire ni aucune remarque.\nLe html produit est propre et ne contient aucun retour à la ligne ou balise non nécessaire."
              },
              {
                role: "user",
                content: "Génère un texte dans la langue du pays suivant (code langue : " + language + ") sur la thématique " + keyword + " de minimum " + length + " mots.\nRespecte une structure de plan claire avec en premier lieu un h1 en guise de titre pour le texte, puis un texte clairement découpé suivant un plan qui apparait en sous-sections (h2, h3).Ne met pas de \\n / retour à la ligne, ni la partie <!DOCTYPE html> utilise plutot des non breaking space. Surtout, à la place des <p>, mets des <span> et évite les <br>\nTu peux t'inspirer des h1 suivants :\n```\n" + h1sString + "\n```\nainsi que des exemples de plans suivants :\n```\n" + plansString + "\n```\nLa dernière section est typiquement une FAQ qui répond aux questions les plus fréquemment posées sur cette thématique : essaie donc d'imaginer dans cette FAQ les questions les plus pertinentes et d'y répondre en un petit paragraphe par question, tu peux également t'inspirer des questions suivantes (note : cette liste est générée automatiquement et peut être vide) :\n````n" + paa + "\n```\nainsi que quelques recherches liées qui là encore peuvent t'inspirer (cette liste peut de même être vide) :\n```\n" + relatedKeywords + "\n```\n\nEnfin, après avoir généré ce texte assure-toi que la plupart des mots-clés de la liste ci-dessous sont bien intégrés, car les outils SEO montrent que les mettre dans le contenu augmente les chances que la page soit bien placée par Google (il y a une indication de fréquence min et max à essayer de respecter au maximum pour chaque mot-clé dans le contenu généré).\nIl se peut qu'il y ait certains mots-clés qui se soient glissés par erreur dans cette liste : utilise ton meilleur jugement afin d'exclure ces quelques erreurs potentielles.\n" + recommendedKeywords + "```"
              }
            ]
          }
        }
      }
    },
    createPromptForOptimization(content, keyword, length, h1sString, plansString, paa, relatedKeywords, recommendedKeywords) {
      return {
        data: {
          type: "AI_GENERATION_REQUEST",
          attributes: {
            model: "gpt-4o",
            messages: [
              {
                role: "system",
                content: "Tu es un rédacteur professionnel spécialisé dans l'écriture de contenu de site web de haute qualité, optimisé avec toutes les meilleures pratiques SEO.\nTa mission est ici d'optimiser des textes déjà écrits pour respecter les bonnes pratiques SEO, de corriger les fautes d'orthographe, de grammaire et de vocabulaire et éventuellement d'enrichir le contenu. Tu adhères cependant à la structure générale du texte fourni par tes clients. Le contenu que tu génères est formatté en html, afin que le texte soit dynamique et visuellement riche, tu emploies judicieusement les espacements, séparations en paragraphes, et tu mets en valeur certains mots et expressions importantes en gras. Tu peux éventuellement créer des sections additionnelles par rapport au contenu original mais tu n'en supprimes jamais afin d'éviter les plaintes client.\nTu es multi-lingue et sait respecter les différentes conventions orthographiques et références culturelles de chaque pays, par exemple là où l'anglais utilise les apostrophoes ('') pour une citation, le français utilise les guillements («»), les espaces diffèrent également (le français par exemple sépare par deux espaces certains signes de ponctuation comme le point d'interrogation, d'exclamation ... La façon de génerer les majuscules n'est également pas la même).\nLe contenu que tu génères est automatiquement intégré par le client sur son site, donc il ne comporte aucun commentaire ni aucune remarque."
              },
              {
                role: "user",
                content: "Tu reçois le texte suivant sur la thématique " + keyword + " : \n\n```txt\n" + content + "\n```\n\n .Complète-le si nécessaire pour qu'il fasse au minimum " + length + " mots.\nRespecte une structure de plan claire avec en premier lieu un h1 en guise de titre pour le texte, puis un texte clairement découpé suivant un plan qui apparait en sous-sections (h2, h3), .Ne met pas de \\n / retour à la ligne, ni la partie <!DOCTYPE html> utilise plutot des non breaking space. Surtout, à la place des <p>, mets des <span> et évite les <br>. si le texte existant est déjà clairement structuré reprends pour l'essentiel la structure existant sinon tu peux éventuellement t'inspirer des h1 suivants :\n```\n" + h1sString + "\n```\nainsi que des exemples de plans suivants :\n```\n" + plansString + "\n```\nLa dernière section est typiquement une FAQ qui répond aux questions les plus fréquemment posées sur cette thématique : si elle n'exsite pas crée-là (ou complète-là si elle existe) en essayant donc d'imaginer dans cette FAQ les questions les plus pertinentes et d'y répondre en un petit paragraphe par question, tu peux également t'inspirer des questions suivantes (note : cette liste est générée automatiquement et peut être vide) :\n````n" + paa + "\n```\nainsi que quelques recherches liées qui là encore peuvent t'inspirer (cette liste peut de même être vide) :\n```\n" + relatedKeywords + "\n```\n\nEnfin, après avoir généré ce texte assure-toi que la plupart des mots-clés de la liste ci-dessous sont bien intégrés, car les outils SEO montrent que les mettre dans le contenu augmente les chances que la page soit bien placée par Google (il y a une indication de fréquence min et max à essayer de respecter au maximum pour chaque mot-clé dans le contenu généré).\nIl se peut qu'il y ait certains mots-clés qui se soient glissés par erreur dans cette liste : utilise ton meilleur jugement afin d'exclure ces quelques erreurs potentielles.\n" + recommendedKeywords + "```"
              }
            ]
          }
        }
      }
    },
    extractFromRecommandedKeywords(data) {
      const csvLikeRows = [];

      csvLikeRows.push("format csv\nMot-clé, Fréquence min, Fréquence max");

      for (let i = 0; i < Math.min(data.length, 30); i++) {
        const { text, minTargetOccurences, maxTargetOccurences } = data[i];
        const csvRow = `${text},${minTargetOccurences},${maxTargetOccurences}`;
        csvLikeRows.push(csvRow);
      }
      return csvLikeRows.join('\n');
    },
    resetEditor() {
      this.contentText = this.originalEditor;
      this.tagMetaDescription = this.oldTagMetaDescription;
      this.tagTitle = this.oldTagTitle;
    },
    showH1Dialog() {
      this.isH1DialogVisible = true;
    },
    showContentLengthDialog() {
      this.isContentLengthDialogVisible = true;
    },
    showOptimizationSeoDialog() {
      this.isOptimizationSeoDialogVisible = true;
    },
    keywordsToUseCollapseEvent(openeditems) {
      switch (openeditems.length) {
        case 0:
          this.textEditorheight = 750;
          break;
        default:
          this.textEditorheight = 1250;
          break;
      }
    },
    async handleRadioEvent(radioValue, isH1Clicked) {
      if (isH1Clicked) {
        this.radioContentToDisplay = {
          key: isH1Clicked,
          value: "<h1>" + radioValue,
        };
      }
      else this.radioContentToDisplay = { key: isH1Clicked, value: radioValue };
    },
    async handleGenAIEvent(clickValue) {
      await this.callAiGeneration(clickValue);
      this.isLoadingContentExtraction = false;
      this.generateContent = this.aiContentText
    }
  },
  computed: {
    ...mapState(["study"]),

    isDataFinished() {
      return (
        this.isLoading ||
        this.url != null ||
        this.recommendedKeywords.length > 0
      );
    },
  },
  mounted() {
    this.callContentExtraction();
  },
  watch: {
    contentOptimizationData() {
      this.$emit("contentOptimizationFetch", this.contentOptimizationData);
    },
    isLoading() {
      this.$emit("isLoading", this.isLoading);
    },
  },
};
</script>
<style scoped lang="scss">
.doc-plan-action {
  margin-bottom: 1rem;
}
.progress-bar {
  transform: scale(0.85);
  background-color: white;
  ::v-deep .el-progress__text {
    font-size: 1.25rem !important;
  }

  ::v-deep .el-progress-circle {
    height: 90px !important;
    width: 90px !important;
  }
}

.detailed-score {
  display: flex;
  align-items: center;
}

.content {
  display: flex;
  .right {
    flex: 1;
    padding-left: 1rem;
  }
}

.title {
  align-items: center;
}

.text-options {
  display: flex;
  padding-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
}

.keywords {
  display: flex;
  column-gap: 0.5em;
  grid-row-gap: 0.3em;
  flex-wrap: wrap;
  margin-top: 0.5rem;

  .keyword {
    .el-tag {
      word-break: break-word;
      white-space: normal;
      height: auto;
    }
  }
}

.file-title {
  margin-top: 1rem;
}

.edit-save-links {
  display: flex;
  .save {
    margin-left: 5px;
  }

  .edit {
    margin-left: auto;
  }

  .cancel {
    margin-left: auto;
    color: #ff6666;
  }
}

.editor {
  height: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
}
.tags-inputs {
  display: flex;
  flex-direction: "horizontal";
  margin-bottom: 1rem;

  .input {
    flex: 1;
    flex-grow: 1;
  }
}

.chatgptSelectors {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  border-radius: 5px;
  margin: 1em 0;
  padding: 0.2em 1.5em;
  background-color: #f7f7f9;
  gap: 15px;
}

.clicked {
  color: #3c54a5;
  background-color: #fff !important;
}

:focus {
  outline: none !important;
}

.buttonNotClicked {
  background-color: #f7f7f9;
  border: none;
  width: 45%;
}

.loadingTextStyle {
  width: 100%;
  text-align: center;
}
.loadingStyle {
  height: 32px;
  width: 100%;
  text-align: center;
}
</style>

<i18n>
{
  "en": {
    "seoScoreGeneration":"Generating SEO scores... This can take up to a few minutes",
    "documentationDesc": "How to test the SEO optimization of your content ?",
    "semanticContent": "Semantic Content",
    "edit": "Modifier",
    "save": "Save",
    "cancel": "Cancel",
    "textOfYourPage": "Text on your page",
    "extractContentWithAi": "Extract text with ai",
    "tooltipExtractContent": "If the text obtained through basic extraction does not meet your expectations, you can use AI-assisted extraction.",
    "reloadOriginalText": "Reload the original text",
    "overOptimized": "Careful not to over-optimize",
    "nbOccurences": "Nb. occurences",
    "recommendedKeywords": "Recommended Keywords",
    "relatedKeywords": "Related searches",
    "peopleAlsoAskKeywords": "People Also Ask",
    "recommendedKeywordsExplanation": "Enrich your text with these keywords to get better SEO results.",
    "relatedKeywordsExplanation": "These keywords have a similar thematic",
    "peopleAlsoAskKeywordsExplanation": "Questions linked to the thematic",
    "refreshScores": "Refresh scores",
    "multipleH1sDetected": "multiple H1s detected",
    "content": "Content relevancy",
    "canceled": "Canceled",
    "pageAssociated": "Page associated",
    "validate": "Validate",
    "length": "Content length",
    "h1Quality": "h1 Quality",
    "h1TooLong": "your h1 is too long",
    "h1TooShort": "your h1 is too short",
    "associatePage": "Associate a page to this keyword",
    "linkingPage": "Indicate a page you would like to like to the keyword:",
    "warningMessage": "This keyword is not associated to any URL. You, therefore, do not have access to any tab but are allowed to test your content. Associate a page to the keyword to start its analysis",
    "incomplete": "SmartKeyword is only extracting the useful content from your page, so it is possible that some part of your original text is missing or that irrelevant elements are also extracted",
    "h1Tag": "H1 tag",
    "characters": "characters",
    "warning": "Warning",
    "crawlerProblem": "A problem occurred during the crawl",
    "tagMetaDescription": "Meta Description tag",
    "tagTitle": "Title tag",
    "inspirations": "Inspirations",
    "seeMore":"View more",
    "dataFetchGpt":"Fetching data from Chatgpt, this will take a few momeents depending on Chatgpt servers"
  },
  "fr": {
    "seoScoreGeneration":"Génération des scores SEO... Cela peut prendre jusqu'à quelques minutes",
    "documentationDesc": "Comment tester l'optimisation SEO de votre contenu ?",
    "semanticContent": "Contenu Sémantique",
    "edit": "Modifier",
    "save": "Sauvegarder",
    "cancel": "Annuler",
    "textOfYourPage": "Texte de votre page",
    "extractContentWithAi": "Extraire le texte avec l'ai",
    "tooltipExtractContent": "Si le texte obtenu par l'extraction de base ne correspond pas à vos attentes, vous pouvez recourir à l'extraction assistée par l'IA.",
    "reloadOriginalText": "Recharger le texte d'origine",
    "overOptimized": "Attention à la suroptimisation",
    "recommendedKeywords": "Mots-clés recommandés",
    "relatedKeywords": "Recherches associées",
    "peopleAlsoAskKeywords": "People Also Ask",
    "nbOccurences": "Nb. occurences",
    "recommendedKeywordsExplanation": "Enrichissez votre texte avec ces mots-clés pour obtenir un meilleur résultat SEO.",
    "relatedKeywordsExplanation": "Mots-clés ayant une thématique proche",
    "peopleAlsoAskKeywordsExplanation": "Questions liées à la thématique",
    "refreshScores": "Rafraîchir les scores",
    "multipleH1sDetected": "plusieurs h1s détectés",
    "content": "Pertinence du contenu",
    "canceled": "Annulé",
    "pageAssociated": "Page associée",
    "validate": "Valider",
    "length": "Longueur du contenu",
    "h1Quality": "Qualité H1",
    "h1TooLong": "votre h1 est trop long",
    "h1TooShort": "votre h1 est trop court",
    "associatePage": "Associer une page à ce mot-clé",
    "linkingPage": "Indiquez une page à lier au mot clé :",
    "warningMessage": "Ce mot-clé n'est associé à aucune URL. Vous n'avez, par conséquent, pas accès aux différents onglets car ils ne contiennent aucune donnée mais vous pourrez néanmoins tester votre contenu. Associez une page si vous souhaiter l'analyser.",
    "incomplete": "SmartKeyword essaie d'extraire uniquement le contenu utile de la page, mais il est possible que du texte soit manquant ou que des éléments non pertinents soient extraits",
    "h1Tag": "Balise h1",
    "characters": "caractères",
    "warning": "Attention",
    "crawlerProblem": "Un problème est survenu lors du crawl",
    "tagMetaDescription": "Balise Méta-description",
    "tagTitle": "Balise Titre",
    "inspirations": "Inspirations",
    "seeMore":"Voir plus",
    "dataFetchGpt":"Récupération des données de Chatgpt, cela prendra quelques instants en fonction des serveurs de Chatgpt"
  },
  "de": {
    "seoScoreGeneration":"Generierung der SEO-Scores ... Dies kann bis zu einigen Minuten dauern",
    "documentationDesc": "Wie können Sie die SEO-Optimierung Ihrer Inhalte testen?",
    "semanticContent": "Semantischer Inhalt",
    "edit": "Modifikator",
    "save": "Zu schützen",
    "cancel": "Stornieren",
    "textOfYourPage": "Ihr Seitentext",
    "extractContentWithAi": "Text mit KI extrahieren",
    "tooltipExtractContent": "Wenn der durch die Basisextraktion gewonnene Text nicht Ihren Erwartungen entspricht, können Sie die KI-gestützte Extraktion verwenden.",
    "reloadOriginalText": "Originaltext neu laden",
    "overOptimized": "Hüten Sie sich vor Überoptimierung",
    "recommendedKeywords": "Empfohlene Schlüsselwörter",
    "relatedKeywords": "verbundene Forschungen",
    "peopleAlsoAskKeywords": "Die Leute fragen auch",
    "nbOccurences": "Nb. Vorkommnisse",
    "recommendedKeywordsExplanation": "Bereichern Sie Ihren Text mit diesen Schlüsselwörtern, um ein besseres SEO-Ergebnis zu erzielen.",
    "relatedKeywordsExplanation": "Keywords mit ähnlichem Thema",
    "peopleAlsoAskKeywordsExplanation": "Themenbezogene Fragen",
    "refreshScores": "Partituren aktualisieren",
    "multipleH1sDetected": "mehrere h1s erkannt",
    "content": "Relevanz des Inhalts",
    "canceled": "Abgesagt",
    "pageAssociated": "Verwandte Seite",
    "validate": "Bestätigen",
    "length": "Inhaltslänge",
    "h1Quality": "H1-Qualität",
    "h1TooLong": "dein h1 ist zu lang",
    "h1TooShort": "dein h1 ist zu kurz",
    "associatePage": "Verknüpfen Sie eine Seite mit diesem Schlüsselwort",
    "linkingPage": "Geben Sie eine Seite an, die mit dem Schlüsselwort verlinkt werden soll:",
    "warningMessage": "Dieses Schlüsselwort ist keiner URL zugeordnet. Sie haben daher keinen Zugriff auf die verschiedenen Registerkarten, da diese keine Daten enthalten, aber Sie können Ihre Inhalte trotzdem testen. Ordnen Sie eine Seite zu, wenn Sie sie analysieren möchten.",
    "incomplete": "SmartKeyword versucht, nur nützliche Inhalte von der Seite zu extrahieren, aber es ist möglich, dass Text fehlt oder irrelevante Elemente extrahiert werden",
    "h1Tag": "h1-Tag",
    "characters": "Figuren",
    "warning": "Aufmerksamkeit",
    "crawlerProblem": "Beim Crawlen ist ein Problem aufgetreten",
    "tagMetaDescription": "Meta-Beschreibungs-Tag",
    "tagTitle": "Titel-Tag",
    "inspirations": "Inspirationen",
    "seeMore":"Mehr sehen",
    "dataFetchGpt":"Abrufen von Daten aus Chatgpt, dies kann je nach Chatgpt-Servern einige Augenblicke dauern"
  }
}
</i18n>
